import { render, staticRenderFns } from "./videoBxt.vue?vue&type=template&id=5ff3b596&scoped=true&"
import script from "./videoBxt.vue?vue&type=script&lang=js&"
export * from "./videoBxt.vue?vue&type=script&lang=js&"
import style0 from "./videoBxt.vue?vue&type=style&index=0&id=5ff3b596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff3b596",
  null
  
)

export default component.exports